import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.desktop.shared.medical-documentation': {
         close: 'Zamknij',
         email: 'Adres e-mail',
         filePassword: 'Hasło do pliku',
         fillPatientEmail: 'Uzupełnij adres e-mail pacjenta...',
         invalidCertificateWarning: 'Nie udało się podpisać dokumentu. Spróbuj ponownie za chwilę.',
         myAccount: 'Moje konto',
         noValidPersonalCertificateWarning:
            'Nie udało się podpisać dokumentu - certyfikat osobisty jest nieaktualny, zaktualizuj go w <link />.',
         phoneNumber: 'Numer telefonu',
         smsWithPasswordToEncryptedDocumentsWillBeSentToThisNumber:
            'Na ten numer zostanie wysłany SMS z hasłem do zaszyfrowanych dokumentów.',
      },
   },
};

export const translationKeys = createScopedTranslationKeys(
   translations.pl,
   '~libs.desktop.shared.medical-documentation'
);
